<template>
    <div :class="emoticonWrapperMergedClasses">
        <svg class="h-full fill-none" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
            <g v-if="type === 'success'">
                <g fill="currentColor" class="pointer-events-none">
                    <path
                        d="M27.4833 23.55C26.6667 23.0833 25.65 23.3667 25.2 24.1667C24.1833 26.1333 22.1833 27.4 19.9833 27.4833C17.7667 27.4 15.765 26.1333 14.765 24.15C14.2817 23.35 13.2483 23.1 12.465 23.5833C11.6983 24.0333 11.4317 25 11.8483 25.7667C13.4317 28.7833 16.5317 30.7 19.965 30.7667C23.3817 30.7 26.4817 28.7667 28.0817 25.75C28.5317 24.9333 28.2483 23.9167 27.4483 23.4667L27.4833 23.55Z"
                    />
                    <path
                        d="M13.3333 11.6667C12.4493 11.6667 11.6014 12.0179 10.9763 12.643C10.3512 13.2681 10 14.1159 10 15C10 15.8841 10.3512 16.7319 10.9763 17.357C11.6014 17.9821 12.4493 18.3333 13.3333 18.3333C14.2174 18.3333 15.0652 17.9821 15.6904 17.357C16.3155 16.7319 16.6667 15.8841 16.6667 15C16.6667 14.1159 16.3155 13.2681 15.6904 12.643C15.0652 12.0179 14.2174 11.6667 13.3333 11.6667Z"
                    />
                    <path
                        d="M26.6667 11.6667C25.7826 11.6667 24.9348 12.0179 24.3096 12.643C23.6845 13.2681 23.3333 14.1159 23.3333 15C23.3333 15.8841 23.6845 16.7319 24.3096 17.357C24.9348 17.9821 25.7826 18.3333 26.6667 18.3333C27.5507 18.3333 28.3986 17.9821 29.0237 17.357C29.6488 16.7319 30 15.8841 30 15C30 14.1159 29.6488 13.2681 29.0237 12.643C28.3986 12.0179 27.5507 11.6667 26.6667 11.6667Z"
                    />
                </g>
            </g>
            <g v-if="type === 'warning'">
                <g fill="currentColor" class="pointer-events-none">
                    <path
                        d="M28.3333 24.8H11.6667C10.7333 24.8 10 25.504 10 26.4C10 27.28 10.7333 28 11.6667 28H28.3333C29.25 28 30 27.28 30 26.4C30 25.504 29.25 24.8 28.3333 24.8Z"
                    />
                    <path
                        d="M13.3333 12C12.4493 12 11.6014 12.3371 10.9763 12.9373C10.3512 13.5374 10 14.3513 10 15.2C10 16.0487 10.3512 16.8626 10.9763 17.4627C11.6014 18.0629 12.4493 18.4 13.3333 18.4C14.2174 18.4 15.0652 18.0629 15.6904 17.4627C16.3155 16.8626 16.6667 16.0487 16.6667 15.2C16.6667 14.3513 16.3155 13.5374 15.6904 12.9373C15.0652 12.3371 14.2174 12 13.3333 12Z"
                    />
                    <path
                        d="M26.6667 12C25.7826 12 24.9348 12.3371 24.3096 12.9373C23.6845 13.5374 23.3333 14.3513 23.3333 15.2C23.3333 16.0487 23.6845 16.8626 24.3096 17.4627C24.9348 18.0629 25.7826 18.4 26.6667 18.4C27.5507 18.4 28.3986 18.0629 29.0237 17.4627C29.6488 16.8626 30 16.0487 30 15.2C30 14.3513 29.6488 13.5374 29.0237 12.9373C28.3986 12.3371 27.5507 12 26.6667 12Z"
                    />
                </g>
            </g>
            <g v-if="type === 'error'">
                <g fill="currentColor" class="pointer-events-none">
                    <path
                        d="M19.9667 23.2667C16.5333 23.3167 13.4667 25.3167 11.8833 28.3333C11.4 29.1167 11.65 30.1333 12.4333 30.6167C13.2167 31.0833 14.2333 30.8333 14.7167 30.05C14.7333 30.0167 14.75 29.9833 14.7667 29.95C15.7667 27.9667 17.7667 26.7 19.9833 26.6167C22.1833 26.6833 24.1833 27.95 25.2 29.9333C25.6667 30.7167 26.7 30.9667 27.4833 30.4833C28.2333 30.0167 28.5 29.05 28.0833 28.2833C26.4833 25.25 23.3833 23.3333 19.9667 23.2667Z"
                    />
                    <path
                        d="M13.3333 11.6667C12.4493 11.6667 11.6014 12.0179 10.9763 12.643C10.3512 13.2681 10 14.116 10 15C10 15.8841 10.3512 16.7319 10.9763 17.357C11.6014 17.9821 12.4493 18.3333 13.3333 18.3333C14.2174 18.3333 15.0652 17.9821 15.6904 17.357C16.3155 16.7319 16.6667 15.8841 16.6667 15C16.6667 14.116 16.3155 13.2681 15.6904 12.643C15.0652 12.0179 14.2174 11.6667 13.3333 11.6667Z"
                    />
                    <path
                        d="M26.6667 11.6667C25.7826 11.6667 24.9348 12.0179 24.3096 12.643C23.6845 13.2681 23.3333 14.116 23.3333 15C23.3333 15.8841 23.6845 16.7319 24.3096 17.357C24.9348 17.9821 25.7826 18.3333 26.6667 18.3333C27.5507 18.3333 28.3986 17.9821 29.0237 17.357C29.6488 16.7319 30 15.8841 30 15C30 14.116 29.6488 13.2681 29.0237 12.643C28.3986 12.0179 27.5507 11.6667 26.6667 11.6667Z"
                    />
                </g>
            </g>
            <g v-if="type === 'neutral'">
                <g fill="currentColor" class="pointer-events-none">
                    <path
                        d="M18.1933 14.8333C18.5267 13.9667 18.11 13 17.26 12.65C16.4267 12.3167 15.51 12.6833 15.1267 13.4833C14.56 14.7333 13.0933 15.3167 11.8267 14.7667C11.2433 14.5 10.7767 14.05 10.5267 13.4667C10.1433 12.6167 9.16001 12.2333 8.32667 12.6167C7.47667 12.9833 7.09334 13.95 7.46001 14.7833V14.7667C8.74334 17.7167 12.1767 19.0667 15.1267 17.7667C16.46 17.1667 17.61 16.1833 18.1933 14.8333Z"
                    />
                    <path
                        d="M31.6333 12.6333C30.7833 12.25 29.8 12.65 29.4333 13.4833C28.8667 14.7333 27.4 15.3167 26.1333 14.7667C25.55 14.5 25.0833 14.05 24.8333 13.4667C24.4833 12.6 23.5167 12.1833 22.65 12.5333C21.7833 12.8667 21.3667 13.8333 21.7167 14.7C21.7167 14.7167 21.7333 14.75 21.75 14.7833C23.0333 17.7333 26.4667 19.0833 29.4167 17.7833C30.75 17.1833 31.8333 16.1167 32.4167 14.7667C32.7833 13.9167 32.3833 12.9333 31.55 12.5667L31.6333 12.6333Z"
                    />
                    <path d="M23 28C23 29.6569 21.6569 31 20 31C18.3432 31 17 29.6569 17 28C17 26.3431 18.3432 25 20 25C21.6569 25 23 26.3431 23 28Z" />
                </g>
            </g>
            <g v-if="type === 'neutral-light'">
                <g fill="currentColor" class="pointer-events-none">
                    <path
                        d="M18.1933 14.8333C18.5267 13.9667 18.11 13 17.26 12.65C16.4267 12.3167 15.51 12.6833 15.1267 13.4833C14.56 14.7333 13.0933 15.3167 11.8267 14.7667C11.2433 14.5 10.7767 14.05 10.5267 13.4667C10.1433 12.6167 9.16001 12.2333 8.32667 12.6167C7.47667 12.9833 7.09334 13.95 7.46001 14.7833V14.7667C8.74334 17.7167 12.1767 19.0667 15.1267 17.7667C16.46 17.1667 17.61 16.1833 18.1933 14.8333Z"
                    />
                    <path
                        d="M31.6333 12.6333C30.7833 12.25 29.8 12.65 29.4333 13.4833C28.8667 14.7333 27.4 15.3167 26.1333 14.7667C25.55 14.5 25.0833 14.05 24.8333 13.4667C24.4833 12.6 23.5167 12.1833 22.65 12.5333C21.7833 12.8667 21.3667 13.8333 21.7167 14.7C21.7167 14.7167 21.7333 14.75 21.75 14.7833C23.0333 17.7333 26.4667 19.0833 29.4167 17.7833C30.75 17.1833 31.8333 16.1167 32.4167 14.7667C32.7833 13.9167 32.3833 12.9333 31.55 12.5667L31.6333 12.6333Z"
                    />
                    <path d="M23 28C23 29.6569 21.6569 31 20 31C18.3432 31 17 29.6569 17 28C17 26.3431 18.3432 25 20 25C21.6569 25 23 26.3431 23 28Z" />
                </g>
            </g>
        </svg>
    </div>
</template>

<script lang="ts" setup>
    import { computed } from 'vue'
    import { twMerge } from 'tailwind-merge'

    const props = withDefaults(
        defineProps<{
            class?: string // Allow `class` prop for custom classes
            type?: 'success' | 'warning' | 'error' | 'neutral' | 'neutral-light'
            state?: 'default' | 'toggle-default' | 'toggle-inactive' | 'toggle-active'
        }>(),
        {
            type: 'success',
            class: undefined,
            state: 'default'
        }
    )

    // Use computed property to determine the class based on the type
    const typeClasses = computed(() => {
        const stateClasses = {
            default: {
                success: 'bg-success-500 text-success-600',
                warning: 'bg-warning-500 text-warning-600',
                error: 'bg-error-400 text-error-600',
                neutral: 'bg-gold-200 text-gray-500',
                'neutral-light': 'bg-system-light text-gray-500'
            },
            'toggle-default': {
                success: 'bg-success-500 text-success-600 hover:bg-success-400',
                warning: 'bg-warning-500 text-warning-600 hover:bg-warning-400',
                error: 'bg-error-400 text-error-600 hover:bg-error-300',
                neutral: 'bg-gold-200 text-gray-500 hover:bg-gold-100',
                'neutral-light': 'bg-system-light text-gray-500 hover:bg-surface-background'
            },
            'toggle-inactive': {
                success: 'bg-surface-background text-neutral-200 hover:bg-success-500 hover:text-success-700',
                warning: 'bg-surface-background text-neutral-200 hover:bg-warning-500 hover:text-warning-700',
                error: 'bg-surface-background text-neutral-200 hover:bg-error-400 hover:text-error-700',
                neutral: 'bg-surface-background text-neutral-200 hover:bg-gold-200 hover:text-default',
                'neutral-light': 'bg-surface-background text-neutral-200 hover:bg-system-light hover:text-gray-500'
            },
            'toggle-active': {
                success: 'bg-success-500 hover:bg-success-400 text-success-600 hover:text-success-700',
                warning: 'bg-warning-500 hover:bg-warning-400 text-warning-600 hover:text-warning-700',
                error: 'bg-error-400 hover:bg-error-300 text-error-600 hover:text-error-700',
                neutral: 'bg-blue-300 hover:bg-blue-300 text-default hover:text-default',
                'neutral-light': 'bg-blue-300 hover:bg-blue-300 text-default hover:text-default'
            }
        }

        return stateClasses[props.state][props.type]
    })

    // Allow overriding base classes
    const emoticonWrapperBaseClasses = computed(() => [
        'w-8 aspect-square rounded-full transition-all duration-300 ease cursor-pointer flex active:shadow-inner',
        typeClasses.value
    ])
    const emoticonWrapperMergedClasses = computed(() => twMerge(emoticonWrapperBaseClasses.value, props.class))
</script>
